var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.17 56h-18.33a3.92 3.92 0 0 1 -3.84-4v-40a3.92 3.92 0 0 1 3.84-4h18.33a3.92 3.92 0 0 1 3.83 4v3.89a2 2 0 1 1 -4 0v-3.89h-18v40h18v-4.11a2 2 0 0 1 4 0v4.11a3.92 3.92 0 0 1 -3.83 4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m56.13 56h-18.33a3.92 3.92 0 0 1 -3.8-4v-4a2 2 0 1 1 4 0v4h18v-40h-18v3.94a2 2 0 1 1 -4 0v-3.94a3.92 3.92 0 0 1 3.8-4h18.33a3.92 3.92 0 0 1 3.87 4v40a3.92 3.92 0 0 1 -3.87 4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m29.35 30.58-.05-.06-5.66-5.66a2 2 0 0 0 -2.83 2.83l2.33 2.31h-9.14a2 2 0 0 0 0 4h9.19l-2.3 2.3a2 2 0 0 0 2.83 2.83l5.66-5.66a2.88 2.88 0 0 0 .27-.34 2 2 0 0 0 -.26-2.56z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m50 30h-9.14l2.32-2.33a2 2 0 0 0 -2.83-2.83l-5.65 5.69-.06.07a2 2 0 0 0 -.64 1.4 2.05 2.05 0 0 0 .34 1.12 2.24 2.24 0 0 0 .27.34l5.66 5.66a2 2 0 0 0 2.83-2.83l-2.25-2.29h9.15a2 2 0 0 0 0-4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegular);
export default __webpack_public_path__ + "static/media/Regular.7958aba2.svg";
export { ForwardRef as ReactComponent };